// extracted by mini-css-extract-plugin
export default {"modal-content":"styles_modal-content__DHMV0","modal-content-description":"styles_modal-content-description__TINOY"};